import React, {useEffect, useState} from 'react';
import ErrorIcon from '../Assets/SVG/ErrorIcon';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {buildUrlAndOpenSameWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';

const ErrorScreen = (props) => {
  return (
    <>
      <div style={{margin: '36px 0 24px 0'}}>
        <ErrorIcon />
      </div>
      <div className='headBox'>
        <p className='heading'>
          משהו השתבש ולא הצלחנו לבדוק
          <br />
          את המכשיר שלך
        </p>
      </div>
      <div className='headBox'>
        <p className='subHeading' style={{marginBottom: '12px'}}>
          אפשר גם ליצור איתנו קשר
        </p>
        {isMobile ? (
          <BtnWhiteBlackBorderBigSize
            text={`חייגו ${window.Config.technicalSupportPhone} לנציג שירות`}
            onclick={() => {
              window.open(`tel:${window.Config.technicalSupportPhone}`);
            }}
          />
        ) : (
          <p className='subHeading'>חייגו ${window.Config.technicalSupportPhone} לנציג שירות</p>
        )}
      </div>
      {props.isAuthMode && (
        <div className='finishFooter'>
          <BtnWhiteBlackBorderBigSize
            text='לאזור האישי'
            onclick={() => {
              buildUrlAndOpenSameWindow(Config.lobbyUrl);
            }}
          />
        </div>
      )}
    </>
  );
};

export default ErrorScreen;
